import React, { useEffect } from 'react';
import SessionManager from '../routes/SessionManager';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function Logout() {

    useEffect(() => {
        userActivity();
    }, []);

    const userActivity = () => {
        var sessionManager = new SessionManager();
        let user = sessionManager.readCookie('user', false);
        let user_activity = sessionManager.readCookie('user_activity', false);

        if (user_activity && user_activity.site_id && user_activity.site_id.length > 0) {
            user_activity.logout_timestamp = new Date().getTime();
            sessionManager.storeCookie('user_activity', user_activity);
            let data = {
                user_login: user.user_login,
                user_token: user.user_token,
                operation: "create",
                form_input: {
                    "object": "user_activity",
                    "attributes": ["site_id", "activity", "start_timestamp", "user_login"],
                    "records": JSON.stringify([[JSON.stringify(user_activity.site_id), JSON.stringify(user_activity), user_activity.site_activity[0].start_time, user_activity.user_login]]),
                }
            };

            CommonUtils.ajax(
                {
                    url: API.DATA.EXPLORER,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status && res.status.code === 200) {
                        console.log("You are successfully logged out ....");
                    }

                });

        }

        sessionManager.removeCookie('user');
        sessionManager.removeCookie('procore');
        sessionManager.removeCookie('user_activity');
        sessionManager.removeCookie('templates');

        setTimeout(() => {
            const history = require("history").createBrowserHistory({ forceRefresh: true });
            history.replace('/');
        }, 2000);
    }

    return (
        <div className='p-2'>You are successfully logged out ....</div>
    );
}

export default Logout;